module.exports = __webpack_public_path__ + "img/step4.1c394fe2.png";